/**
 * Route, listing entry and icon of the Foundation membership control panel.
 * @module config/routes
 */

import type { ConfigType } from '@plone/registry';
import groupSVG from '@plone/volto/icons/group.svg';

import MembershipControlPanel from '../components/ControlPanel/MembershipControlPanel';

/** Id of the membership control panel: its listing entry and icon key. */
export const MEMBERSHIP_CONTROLPANEL = 'membership';

/** Where the membership control panel lives. */
export const MEMBERSHIP_CONTROLPANEL_PATH = `/controlpanel/${MEMBERSHIP_CONTROLPANEL}`;

/**
 * Install the membership control panel.
 *
 * @param config The Volto configuration registry.
 * @returns The registry, for chaining.
 */
export default function install(config: ConfigType) {
  config.addonRoutes = [
    ...(config.addonRoutes ?? []),
    {
      path: MEMBERSHIP_CONTROLPANEL_PATH,
      exact: true,
      component: MembershipControlPanel,
    },
  ];
  // Listed in Site Setup beside Users and Groups.
  config.settings.controlpanels = [
    ...(config.settings.controlpanels ?? []),
    {
      '@id': `/${MEMBERSHIP_CONTROLPANEL}`,
      group: 'Users',
      title: 'Foundation Membership',
    },
  ];
  config.settings.controlPanelsIcons = {
    ...config.settings.controlPanelsIcons,
    [MEMBERSHIP_CONTROLPANEL]: groupSVG,
  };

  return config;
}
